module.exports = __webpack_public_path__ + "media/images/clients/coins-542d8a6f40c252ec980eefac45cb4fd4.png";